import { Icon, type IconName } from "@-/dev.improve.haniverse.components.ui.icon";
import { createElement } from "react";
import type { ColorValue } from "@-/com.npmjs.react-native";

const detailsTabIconDict: Record<string, IconName> = {
  caligraphy: "LuPaintbrush",
  characters: "HanziZi",
  composition: "LuComponent",
  compounds: "LuComponent",
  dictionary: "LuBookOpen",
  learningProgress: "LuLibrary",
  mnemonics: "MdLightbulbOutline",
  progress: "LuLibrary",
  sentences: "LuMessageSquare",
  strokes: "LuPaintbrush",
};

export function detailsTabBarIcon(routeName: string) {
  return ({
    className,
    color,
    size = 18,
  }: {
    className?: string;
    color?: ColorValue;
    focused: boolean;
    size?: number;
  }) =>
    createElement(Icon, {
      className,
      color,
      name: detailsTabIconDict[routeName] ?? "LuHelpCircle",
      size,
    });
}
